;(function() {
  'use strict'

  angular.module('core.addPageLinksDialog', [])
})()
